import $ from "jquery";

class ImajizeFileReader {


    async getAllFileEntries(dataTransferItemList) {
        const that = this

        let fileEntries = []
        // Use BFS to traverse entire directory/file structure
        let queue = []

        // Unfortunately dataTransferItemList is not iterable i.e. no forEach
        for (let i = 0; i < dataTransferItemList.length; i++) {
            queue.push(dataTransferItemList[i].webkitGetAsEntry())
        }

        while (queue.length > 0) {
            let entry = queue.shift()
            if (entry.isFile) {
                fileEntries.push(entry)
            } else if (entry.isDirectory) {
                let reader = entry.createReader()
                queue.push(...(await this.readAllDirectoryEntries(reader)))
            }
        }
        // return fileEntries;
        return Promise.all(
            fileEntries.map((entry) => this.readEntryContentAsync(entry))
        )
    }

// Get all the entries (files or sub-directories) in a directory by calling readEntries until it returns empty array
    async readAllDirectoryEntries(directoryReader) {
        let entries = [];
        let readEntries = await this.readEntriesPromise(directoryReader)
        while (readEntries.length > 0) {
            entries.push(...readEntries)
            readEntries = await this.readEntriesPromise(directoryReader)
        }
        return entries
    }

// Wrap readEntries in a promise to make working with readEntries easier
    async readEntriesPromise(directoryReader) {
        try {
            return await new Promise((resolve, reject) => {
                directoryReader.readEntries(resolve, reject)
            });
        } catch (err) {
            console.error(err)
        }
    }

    async readEntryContentAsync(entry) {
        return new Promise((resolve, reject) => {
            entry.file(async (file) => {
                // webkit doesnt the webkitRelativePath to the file on drop
                // so we need to copy it from the entry
                file.fullPath = entry.fullPath
                if (file.fullPath.startsWith('/')) {
                    file.fullPath = file.fullPath.replace('/', '')
                }

                resolve(file)
            })
        })
    }
}

export { ImajizeFileReader };